import { ProductType } from './util.types';

export enum OrderStatus {
  PROCESSING = 10, // Sipariş hazırlanıyor
  SHIPPED = 20, // Sipariş kargoya verildi
  DELIVERED = 30, // Sipariş teslim edildi
  CANCELLED = 40, // Sipariş iptal edildi
  RETURNED = 50, // Sipariş iade edildi
}

export const OrderStatusLabel = new Map<OrderStatus, string>([
  [OrderStatus.PROCESSING, 'Hazırlanıyor'],
  [OrderStatus.SHIPPED, 'Kargoya Verildi'],
  [OrderStatus.DELIVERED, 'Teslim Edildi'],
  [OrderStatus.CANCELLED, 'İptal Edildi'],
  [OrderStatus.RETURNED, 'İade Edildi'],
]);

export interface ProductVariantDto {
  id: number;
  variantName: string;
  variantValue: string;
  stock?: number;
}

export interface ProductDto {
  id: number;
  name: string;
  price: number;
  isActive: boolean;
  createdAt: Date;
  description?: string;
  title?: string;
  photoUrl?: string;
  photoUrls?: string[];
  variants?: ProductVariantDto[];
  productType: ProductType;
}

export interface SaveOrderItemRequest {
  productId: number;
  variantId?: number;
  quantity: number;
}

export interface SaveOrderAddressRequest {
  fullName: string;
  address: string;
  cityId: number;
  countyId: number;
  phoneNumber: string;
}

export interface SaveOrderRequest {
  items: SaveOrderItemRequest[];
  shippingAddress: SaveOrderAddressRequest;
}

export interface Order {
  id: number;
  items: SaveOrderItemRequest[];
  shippingAddress: SaveOrderAddressRequest;
}

export interface ShippingAddressDto {
  fullName: string;
  address: string;
  cityId: number;
  countyId: number;
  phoneNumber: string;
}

export interface OrderItemDto {
  id: number;
  productName: string;
  productId: number;
  productVariantId: number;
  quantity: number;
  orderId: number;
  unitPrice: number;
  productVariant: {
    id: number;
    variantName: string;
    variantValue: string;
    stock: number;
  };
}

export interface OrderDto {
  id: number;
  userId: number;
  status: OrderStatus;
  expertisePointId: number;
  user: {
    id: number;
    email: string;
    name: string;
    surname: string;
    active: boolean;
    expertisePointId: number;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    expertisePoint: null;
  };
  totalPrice: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface OrderDetailResponse {
  order: OrderDto;
  orderItems: OrderItemDto[];
  shippingAddress: ShippingAddressDto;
}

export interface OrderListItemResponse {
  orderId: number;
  status: OrderStatus;
  statusStr: string;
  totalPrice: number;
  createdAt: Date;
  expertisePointId: number;
  expertisePointName: string;
  userId: number;
  userName: string;
}

export interface OrderListResponse {
  orders: OrderListItemResponse[];
}
